<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <!--        <div v-rblink="{name:'DakejianApply',query:{}}" style="padding: 10px;"> <img style="width: 100%; " src="https://cheeseman.oss-cn-hangzhou.aliyuncs.com/editor/20210308/user-0/20210308/caf9635f9db8148227664f87208f4c69.jpeg?x-oss-process=style/tb-750" /></div>-->
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>
        <van-field
            readonly
            clickable
            name="year"
            :value="formData.year"
            input-align="right"
            label="活动时间"
            readonly
            placeholder="点击选择申报年度"
        />
        <van-popup v-model="showDate" position="bottom">
          <van-datetime-picker
              @cancel="showDate =false"
              title="选择年月"
              type="year-month"
              :default-date='new Date( (formData.year? formData.year :"" ).replace(/-/g,"/") )'
              :min-date="minDate"
              @confirm="onDateConfirm"/>
        </van-popup>

        <van-field name="radio" label="类型"
                   input-align="right">
          <template #input>
            <van-radio-group v-model="formData.type" direction="horizontal">
              <van-radio checked-color="#ffb01b" :name="1">全国啦啦操乡村振兴公益活动先进单位</van-radio>
              <!--              <van-radio checked-color="#ffb01b" :name="2">先进个人</van-radio>-->
            </van-radio-group>
          </template>
        </van-field>
        <van-field
            readonly
            clickable
            :value="formData.extra_saiqu.length ? formData.extra_saiqu[0].name : ''"
            autosize
            type="textarea"
            input-align="right"
            label="选择领取的比赛名称"
            placeholder="点击选择领取的比赛名称"
            @click="showSaiquPicker = true"
        />
        <SaiquPicker
            :show="showSaiquPicker"
            :limit="1"
            :value="formData.extra_saiqu"
            @onChange="onSaiquChange"
            @onClose="showSaiquPicker=false"
            :defaultValue="formData.extra_saiqu"
            @onConfirm="onSaiquConfirm"
        ></SaiquPicker>
        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="省市区"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>

        <van-field
            v-model="formData.danwei"
            :rules="[{ required: true, message: '单位名称不能为空' }]"
            label="单位名称"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入单位名称"
        />
        <van-field
            v-model="formData.address"
            :rules="[{ required: true, message: '请输入详细地址' }]"
            error-message-align="right"
            label="详细地址"
            input-align="right"
            clearable
            placeholder="请输入详细地址"
        />

        <van-field
            v-model="formData.renshu"
            :rules="[{ required: true, message: '人数不能为空' }]"
            error-message-align="right"
            label="参与活动人数"
            type="number"
            input-align="right"
            clearable
            placeholder="请输入人数"
        />


      </van-cell-group>

      <van-divider>全国啦啦操乡村振兴公益活动先进个人
      </van-divider>

      <van-cell-group>

        <van-field
            v-model="formData.jiaoshi_name"
            :rules="[{ required: true, message: '请输入姓名' }]"
            error-message-align="right"
            label="个人姓名（限一人）"
            input-align="right"
            clearable
            placeholder="请输入姓名"
        />


        <van-cell title="视频文件" :value="formData.video.length+'/1'">
        </van-cell>

        <div class="row" style="margin: 10px 0 0 10px" >
          <VideoUploader :minSize="0" :fileList="formData.video" :limit="1"
                         :fileName="formData.danwei+'-'+formData.name"  :name="'video'"></VideoUploader>
        </div>
        <div class="operate-desc-left"  >要求6分钟以内，格式mp4</div>


      </van-cell-group>


      <van-divider>联系人信息</van-divider>
      <van-cell-group>
        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: '请输入姓名' }]"
            error-message-align="right"
            label="姓名"
            input-align="right"
            clearable
            placeholder="请输入姓名"
        />

        <van-field
            v-model="formData.phone"
            :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
            error-message-align="right"
            label="手机"
            input-align="right"
            clearable
            placeholder="请输入手机"
        />

      </van-cell-group>

<!--      加群二维码 https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1636097067736-5.png-->
      <van-divider>加群二维码</van-divider>
      <div class="img-box">
        <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1636097067736-5.png" alt="">
        <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" native-type="button" round>请长按图片保存</van-button>
        <van-button v-else @click="download('加群二维码', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1636097067736-5.png')" style="margin: 10px auto; text-align: center " type="default" native-type="button" round>点击下载二维码</van-button>
      </div>
      <div style="height: 100px"></div>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          提交报名
        </van-button>
      </div>
    </van-form>


    <van-dialog v-model="isShowImg" title="" confirmButtonText="返回列表" @confirm="onConfirm">
      <div class="img-box">
        <div class="img-li">
          <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1635409880815-3.png" alt="">
          <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
          <van-button v-else @click="download" style="margin: 10px auto; text-align: center " type="default" native-type="button" round>点击下载</van-button>
        </div>

        <van-divider>加群二维码</van-divider>
        <div class="img-li">
          <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1636097067736-5.png" alt="">
          <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" native-type="button" round>请长按图片保存</van-button>
          <van-button v-else @click="download('加群二维码', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1636097067736-5.png')" style="margin: 10px auto; text-align: center " type="default" native-type="button" round>点击下载二维码</van-button>
        </div>
      </div>
    </van-dialog>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.img-box {
  max-height: 70vh;
  overflow-y: scroll;
  text-align: center;
  background: rgb(245,245,245);
}
.img-box img{
  width: 80%;
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";
import VideoUploader from '@/components/picker/VideoUploader.vue';
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'RuralApply',
  components: {
    PicUploader, LoginDialog, VideoUploader, SaiquPicker
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      isShowImg: false,
      showArea: false,
      showDate: false,
      showSaiquPicker: false,
      areaList: {},
      areaValue: '',
      submitType: '',

      minDate: new Date( ),
      formData: {
        id: 0,
        year: '2021年10月1日-2022年8月31日',
        type: 1,
        address: '',
        video: [],
        extra_saiqu: [],
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
      },
      isApp: window.isApp()
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = '乡村振兴公益活动申报'

    that.areaList = area;
    that.formData.id = this.$route.query.id;
    that.getUserDetail();
//            if(that.formData.id){
//             this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getUserDetail() {
      let that = this;
      this.$api.get('/api/user/userPage', {}, (res) => {
        console.log(res)
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        } else {
          Toast(res.msg)
        }
      })
    },

    download(name, url) {
      let that = this;
      // console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: name,
          url: url,
        }
      });
    },

    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      // this.formData.datetitle =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
      this.formData.year =  `${date.getFullYear()}-${date.getMonth() + 1}`
    },

    onConfirm() {
      this.isShowImg = false
      setTimeout(() => {
        // rbLink({
        //   name: "CDakejianApplySuccess",
        //   query: {
        //     id: res.data.id
        //   }
        // }, 'replace')

        rbLink({
          name: "",
        }, 'back')
      }, 200)
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.extra_saiqu = [...values];
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }

        if (!this.formData.video.length) {
          Toast.fail('请上传视频');
          return
        }
      }
      that.saveLoading = true;

      that.formData.stationid = that.formData.extra_saiqu.length ? that.formData.extra_saiqu[0].id :0

      that.$api.post('/api/crural/apply', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('提交成功');

        // 弹出联系二维码
        that.isShowImg = true
        return
        setTimeout(() => {
          // rbLink({
          //   name: "CDakejianApplySuccess",
          //   query: {
          //     id: res.data.id
          //   }
          // }, 'replace')

          rbLink({
            name: "",
          }, 'back')
        }, 200)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast(res.msg);
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// RuralApply.vue?2e04c87b